import { Component, OnInit, EventEmitter, Input, OnChanges, Output, ViewEncapsulation, Inject, Injector } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UsersService } from '../../../users/users.service';
import { IMyOptions } from 'mydatepicker';
import { PayorsService} from '../../../payors/payors.service';
import { RiderService } from '../../rider.service';
import { constant } from 'app/app.constants';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';

declare var jQuery: any;

@Component({
  selector: 'app-rider-payor-modal',
  templateUrl: './payor-modal.component.html',
  styleUrls: ['./payor-modal.component.scss']
})
export class PayorModalComponent extends ParentModule implements OnInit, OnChanges {

    public  maskDate= [/[0-1]/, /[0-9]/, '-', /[0-3]/, /[0-9]/, '-', /[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/];
    private modalPayorForm: FormGroup;
    private payorArray: any;
    private planArray: any;
    private isEnabledPlans= false;
    private coverage= 0;
    private clientPayorId = JSON.parse(localStorage.getItem('currentUser')).payorid;
    private isClient = JSON.parse(localStorage.getItem('currentUser')).isClient;
    private lineofbusiness: string;
    private isMemberRequired= false;
    private myDatePickerRiderPayorModalOptions: IMyOptions = {
        dateFormat: 'mm-dd-yyyy',
        editableDateField: false
    };
    private selectedPayor: any;

    private riderPayorData: any;

    @Input() rowSelected: any;
    @Input() rndRiderPayorId: number;
    @Input() payorInlist: any;

    @Output() emitRiderPayorForm: EventEmitter<any> = new EventEmitter<any>();
    @Output() closeRiderPayorModalEmit: EventEmitter<any> = new EventEmitter<any>();

    dateMask = constant.MASKS.DATES.DDMMYYYY

  constructor(private fb: FormBuilder,
              private userService: UsersService,
              private payorService: PayorsService,
              private riderService: RiderService,
              protected Inject: Injector) {
      super('app-rider-payor-modal', Inject);
              }

  ngOnInit() {

      this.createModalPayor();
      this.riderPayorData = this.rowSelected;
      if (this.riderPayorData !== null) {
        if (this.modalPayorForm) {
            this.applyRules(this.modalPayorForm, 'Update');
        }
          this.selectedPayor = this.riderPayorData.payor;
          if (this.riderPayorData.payor.enableplans) {
              this.isEnabledPlans = true;
              this.getPlansByPayor(this.riderPayorData.payorid);
          } else {
              this.isEnabledPlans = false;
          }
          this.modalPayorForm.patchValue({_enableplans: this.isEnabledPlans});
          this.loadRiderPayors(this.riderPayorData);
      } else {
        if (this.modalPayorForm) {
            this.applyRules(this.modalPayorForm, 'Create');
        }
      }

      this.userService.getPayorList().subscribe(
          data => {
              this.assignPayorToDropDownd(data);
          }


      );

    //   if (this.isClient) {
    //       this.modalPayorForm.patchValue({
    //           payorid: this.clientPayorId
    //       });

    //       this.payorService.getPayorsByPayorId(this.clientPayorId).subscribe(
    //           data => {
    //               this.selectedPayor = data;
    //               this.activateControlsByPlan(data.enableplans);
    //           }
    //       );

    //       this.getPlansByPayor(this.clientPayorId);
    //   }
  }

    assignPayorToDropDownd(data) {
      const arrayPayors = [];
      data.map((item) => {
            const payorSkip = this.payorInlist.indexOf(item.payorid);
              if (payorSkip < 0) {
                arrayPayors.push(item);
            }
        });
        this.payorArray = arrayPayors;

    }


    ngOnChanges() {
    }

    loadRiderPayors(data) {
        const DOB = new Date(data.expirationdate);
        this.modalPayorForm.patchValue({
            _enableplans        : this.isEnabledPlans,
            riderpayorid        : data.riderpayorid,
            payorid             : parseInt(data.payorid, 10),
            payordescription    : data.payordescription,
            memberid            : data.memberid,
            groupid             : data.groupid,
            planid              : data.planid,
            isactive            : data.isactive,
            isdefault           : data.isdefault,
            expirationdate      : data.expirationdate,
            startdate           : data.startdate,
            lineofbusiness      : data.lineofbusiness,
            medicaidnumber      : data.medicaidnumber
        });
    }
    createModalPayor() {
        this.modalPayorForm =  this.fb.group({
            _enableplans        : false,
            riderid             : [0],
            riderpayorid        : [this.rndRiderPayorId],
            payorid             : [''],
            payordescription    : [''],
            memberid            : [''],
            groupid             : [''],
            planid              : [''],
            isactive            : [true],
            isdefault           : [false],
            expirationdate      : [''],
            startdate           : [''],
            lineofbusiness      : [''],
            medicaidnumber      : ['']
        });
    }

    onRiderChange(event) {
        const payorId = this.modalPayorForm.get('payorid').value;
        this.getActionsForPayor(payorId);
        this.payorService
          .getPayorsByPayorId(payorId)
          .subscribe(
            data => {
                this.selectedPayor = data;
                this.modalPayorForm.patchValue({_enableplans: data.enableplans});
                this.validatePayorPlan();
            }
        );
        this.modalPayorForm.patchValue({
            payordescription    : jQuery('#selectPayorId option:selected').text()
        });
    }

    getPlansByPayor(payorid) {
        this.payorService.getAllPlans(false, payorid).subscribe(
            data => {
                this.planArray = data;
                if (this.isEnabledPlans) {
                  this.getPlanById();
                }
            }
        );
    }

    getPlanById() {
      if(this.riderPayorData) {
        const planid = this.riderPayorData.planid;
        if (planid) {
            this.payorService.getPlanById(planid).subscribe(
                data => {
                    this.coverage = data.numberoftrips;

                    this.modalPayorForm.patchValue(
                        {
                            lineofbusiness: data.groupname,
                            groupid: data.groupid
                        }
                    );
                }
            );
        }
      }
    }


    onDateChanged(event) {
        this.modalPayorForm.patchValue({
            expirationdate    : event.formatted
        });
    }
    onSubmitRiderPayor(value) {
        value['payor'] = this.selectedPayor;
        value['payorid'] = this.modalPayorForm.get('payorid').value;
        value['groupid'] = this.modalPayorForm.get('groupid').value;
        value['payordescription'] = this.selectedPayor.description;
        if(this.modalPayorForm.get('planid').value) {
          value['plan'] = this.getIsDual(this.modalPayorForm.get('planid').value);
        }
        this.emitRiderPayorForm.emit(value);
    }

    validatePayorPlan() {
        const payorId = this.modalPayorForm.get('payorid').value;
        this.getPlansByPayor(payorId);
        let sw = false;
        this.payorArray.forEach(
            data => {
                if (data.payorid === payorId) {
                    if (data.enableplans) {
                        sw = true;
                    }
                }
            }
        );
        this.activateControlsByPlan(sw);
    }

    activateControlsByPlan(activate) {
        this.isEnabledPlans = activate;
        this.modalPayorForm.patchValue({_enableplans: activate});
    }

    onCloseRiderPayorModal() {
        this.closeRiderPayorModalEmit.emit();
    }
    onCheckActive() {

    }

    getIsDual(planid: number) {
      return this.planArray.filter((row) => {
        return row.planid === planid;
      })[0];
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/riders/components/payor-modal/payor-modal.component.ts